export default "__VITE_ASSET__C3Rmdvx3__"